import {ReloadButton} from '@flexinet/ui-components';
import {useQueryClient} from '@tanstack/react-query';

import {providerMappingsQueryKeys} from '../hooks/providerMappingsQueryKeys';

// Reload starts every provider-mappings list on the page again from page 1. The table
// shows its fetching indicator while it runs (useProviderMappings `fetching`).
export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    return (
        <ReloadButton
            data-testid='provider-mappings-reload'
            onClick={() => queryClient.invalidateQueries({queryKey: providerMappingsQueryKeys.all})}
        />
    );
};
